import dayjs from 'dayjs';

export function prependPreambleAsNeeded(data: string): string {
  return data.length === 0 ? data : `\uFEFFsep=,\n${data}`;
}

export function generateFileName(projectName: string, reportType: string, filetype: string): string {
  return `${dayjs().format('YYYY-MM-DD HHmm')}_${projectName}_${reportType}.${filetype}`;
}
